require('./angular-animate');
module.exports = 'ngAnimate';



//////////////////
// WEBPACK FOOTER
// ./~/angular-animate/index.js
// module id = 564
// module chunks = 2